exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-support[data-v-ac6bc2b4] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  width: 315px;\n  min-height: 434px;\n}\n.mt-45[data-v-ac6bc2b4] {\n  margin-top: -45px;\n}\n.mt-56[data-v-ac6bc2b4] {\n  margin-top: -56px;\n}\n.v-card__actions a[data-v-ac6bc2b4] {\n  text-decoration: none;\n}", ""]);

// exports
